import {
  Actor,
  Gender,
  GenderNeutralNames,
  getDefaultRandomInGameNameType,
  InGameNameMode,
} from "../../models/Actor";
import { GetNewGuid } from "../../helpers/GuidHelper";
import ActorAvatar from "../../components/actors/ActorAvatar";
export class ActorHelper {
  private static getRandomInGameName() {
    return GenderNeutralNames[
      Math.floor(Math.random() * GenderNeutralNames.length)
    ];
  }

  private static getNextWorkingName(actors: Actor[]) {
    const existingNames = new Set(actors.map((actor) => actor.workingName));
    let index = 1;
    let candidate = `NPC ${index}`;

    while (existingNames.has(candidate)) {
      index += 1;
      candidate = `NPC ${index}`;
    }

    return candidate;
  }

  static GetNewRandomActor(actors: Actor[] = []): Actor {
    const workingName = this.getNextWorkingName(actors);
    const inGameName = this.getRandomInGameName();

    return {
      id: GetNewGuid(),
      workingName,
      inGameName,
      inGameNameMode: InGameNameMode.random,
      randomInGameNameType: getDefaultRandomInGameNameType(Gender.random),
      gender: Gender.random,
    };
  }

  static GetActorProfilePicture(actorId: string, allActors: Actor[]) {
    const actor =
      actorId === "player"
        ? allActors.find((a) => a.id === "player") ?? ({ id: "player", workingName: "Player" } as Actor)
        : allActors.find((a) => a.id === actorId);
    return <ActorAvatar actor={actor} size="36" />;
  }
}
